<template>
  <v-container fluid class="mt-4 px-4">
    <v-row>
      <v-col cols="12">
        <v-card class="shadowCard">
          <v-card-title class="text-h5 font-weight-bold">
            <v-icon left color="amber darken-2">mdi-filter-variant</v-icon>
            Embudo de Ventas Fases
            <v-chip small class="ml-3" color="blue darken-1" dark>Fases 1–4</v-chip>
            <v-spacer></v-spacer>
            <v-btn color="amber darken-2" dark @click="consultar" :loading="cargando" small tile>
              <v-icon left small>mdi-refresh</v-icon>
              Consultar
            </v-btn>
          </v-card-title>

          <v-card-text>
            <v-row align="center">
              <v-col cols="12" sm="6" md="3">
                <v-select
                  v-model="escuela"
                  :items="escuelas"
                  item-text="nombre"
                  item-value="id"
                  label="Escuela"
                  dense
                  filled
                  hide-details
                  prepend-icon="mdi-school"
                  @change="onEscuelaChange"
                />
              </v-col>

              <v-col cols="12" sm="6" md="3">
                <v-select
                  v-model="plantelesSel"
                  :items="plantelesEscuela"
                  item-text="plantel"
                  item-value="id_plantel"
                  label="Plantel (opcional)"
                  dense
                  filled
                  hide-details
                  multiple
                  chips
                  small-chips
                  deletable-chips
                  prepend-icon="mdi-map-marker"
                  :no-data-text="cargandoPlanteles ? 'Cargando…' : 'Sin planteles para esta escuela'"
                />
              </v-col>

              <v-col cols="12" sm="6" md="3">
                <v-menu
                  v-model="menuFechaInicio"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="fechaInicio"
                      label="Fecha Inicio"
                      prepend-icon="mdi-calendar"
                      readonly
                      dense
                      filled
                      hide-details
                      v-bind="attrs"
                      v-on="on"
                    />
                  </template>
                  <v-date-picker v-model="fechaInicio" @input="menuFechaInicio = false" locale="es-MX" />
                </v-menu>
              </v-col>

              <v-col cols="12" sm="6" md="3">
                <v-menu
                  v-model="menuFechaFin"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="fechaFin"
                      label="Fecha Fin"
                      prepend-icon="mdi-calendar"
                      readonly
                      dense
                      filled
                      hide-details
                      v-bind="attrs"
                      v-on="on"
                    />
                  </template>
                  <v-date-picker v-model="fechaFin" @input="menuFechaFin = false" locale="es-MX" />
                </v-menu>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <div v-if="datosCargados" class="funnel-wrap mt-6 mb-8">
      <div class="text-caption text-center grey--text mb-3">{{ metaConsulta }}</div>

      <div class="funnel">
        <!-- Fase 1 -->
        <div class="funnel-stage stage-1">
          <div class="funnel-stage__inner">
            <div class="funnel-stage__title">
              <v-icon color="white" small class="mr-1">mdi-bullhorn-outline</v-icon>
              Atracción
            </div>
            <div class="funnel-stage__subtitle">Generar tráfico</div>
            <div v-if="!errorAtraccion" class="funnel-metrics">
              <v-tooltip bottom max-width="280" color="grey darken-3">
                <template v-slot:activator="{ on, attrs }">
                  <div class="funnel-metric" v-bind="attrs" v-on="on">
                    <div class="funnel-metric__label">
                      Alcance
                      <v-icon x-small color="white" class="ml-1">mdi-information-outline</v-icon>
                    </div>
                    <div class="funnel-metric__value">{{ formatNumber(atraccion.alcance) }}</div>
                  </div>
                </template>
                <span>Universo total de individuos distintos a los que la pauta les mostró el anuncio</span>
              </v-tooltip>
              <v-tooltip bottom max-width="280" color="grey darken-3">
                <template v-slot:activator="{ on, attrs }">
                  <div class="funnel-metric" v-bind="attrs" v-on="on">
                    <div class="funnel-metric__label">
                      Interacciones
                      <v-icon x-small color="white" class="ml-1">mdi-information-outline</v-icon>
                    </div>
                    <div class="funnel-metric__value">{{ formatNumber(atraccion.interacciones) }}</div>
                  </div>
                </template>
                <span>Personas únicas que hicieron cualquier acción con los anuncios (likes, clics, comentarios, etc.)</span>
              </v-tooltip>
            </div>
            <div v-else class="funnel-error">{{ errorAtraccion }}</div>
          </div>
        </div>

        <div class="funnel-bridge">
          <div v-if="!errorAtraccion" class="funnel-chips">
            <v-chip
              v-for="chip in chipsFase1"
              :key="chip.id"
              small
              label
              class="ma-1 funnel-chip"
              :color="chip.color"
              dark
              @click="abrirValidacion(chip)"
            >
              <v-icon left x-small>{{ chip.icon }}</v-icon>
              {{ chip.label }}
            </v-chip>
          </div>
          <v-chip
            v-if="!errorAtraccion"
            small
            outlined
            class="funnel-chip-bridge ma-1"
            @click="abrirValidacion(chipPlantelFase1)"
          >
            <v-icon left x-small>mdi-map-marker-off</v-icon>
            {{ chipPlantelFase1.label }}
          </v-chip>
          <v-chip
            v-if="!errorAtraccion && !errorInteraccion"
            small
            outlined
            class="funnel-chip-bridge ma-1"
            @click="abrirValidacion(chipPuente12)"
          >
            <v-icon left x-small>mdi-arrow-down-bold</v-icon>
            {{ chipPuente12.label }}
          </v-chip>
        </div>

        <!-- Fase 2 -->
        <div class="funnel-stage stage-2">
          <div class="funnel-stage__inner">
            <div class="funnel-stage__title">
              <v-icon color="white" small class="mr-1">mdi-message-text-outline</v-icon>
              Interacción
            </div>
            <div class="funnel-stage__subtitle">Crear un vínculo con el prospecto</div>
            <div v-if="!errorInteraccion" class="funnel-metrics">
              <v-tooltip bottom max-width="280" color="grey darken-3">
                <template v-slot:activator="{ on, attrs }">
                  <div class="funnel-metric" v-bind="attrs" v-on="on">
                    <div class="funnel-metric__label">
                      Contactos
                      <v-icon x-small color="white" class="ml-1">mdi-information-outline</v-icon>
                    </div>
                    <div class="funnel-metric__value">{{ formatNumber(interaccion.contactos) }}</div>
                  </div>
                </template>
                <span>Personas de las cuales obtuvimos su número telefónico para iniciar la comunicación</span>
              </v-tooltip>
              <v-tooltip bottom max-width="280" color="grey darken-3">
                <template v-slot:activator="{ on, attrs }">
                  <div class="funnel-metric" v-bind="attrs" v-on="on">
                    <div class="funnel-metric__label">
                      Contacto calificado
                      <v-icon x-small color="white" class="ml-1">mdi-information-outline</v-icon>
                    </div>
                    <div class="funnel-metric__value">{{ formatNumber(interaccion.contactos_calificados) }}</div>
                  </div>
                </template>
                <span>Contestó el chat en el periodo y sostuvo un intercambio real de mensajes bidireccionales</span>
              </v-tooltip>
            </div>
            <div v-else class="funnel-error">{{ errorInteraccion }}</div>
          </div>
        </div>

        <div class="funnel-bridge">
          <div v-if="!errorInteraccion" class="funnel-chips">
            <v-chip
              v-for="chip in chipsFase2"
              :key="chip.id"
              small
              label
              class="ma-1 funnel-chip"
              :color="chip.color"
              dark
              @click="abrirValidacion(chip)"
            >
              <v-icon left x-small>{{ chip.icon }}</v-icon>
              {{ chip.label }}
            </v-chip>
          </div>
          <v-chip
            v-if="!errorInteraccion && !errorConversion"
            small
            outlined
            class="funnel-chip-bridge ma-1"
            @click="abrirValidacion(chipPuente23)"
          >
            <v-icon left x-small>mdi-arrow-down-bold</v-icon>
            {{ chipPuente23.label }}
          </v-chip>
        </div>

        <!-- Fase 3 -->
        <div class="funnel-stage stage-3">
          <div class="funnel-stage__inner">
            <div class="funnel-stage__title">
              <v-icon color="white" small class="mr-1">mdi-cash-check</v-icon>
              Conversión
            </div>
            <div class="funnel-stage__subtitle">Generar ventas / inscripciones</div>
            <div v-if="!errorConversion" class="funnel-metrics">
              <v-tooltip bottom max-width="280" color="grey darken-3">
                <template v-slot:activator="{ on, attrs }">
                  <div class="funnel-metric" v-bind="attrs" v-on="on">
                    <div class="funnel-metric__label">
                      Inscritos
                      <v-icon x-small color="white" class="ml-1">mdi-information-outline</v-icon>
                    </div>
                    <div class="funnel-metric__value">{{ formatNumber(conversion.inscritos) }}</div>
                  </div>
                </template>
                <span>Personas que concretaron su pago inicial y quedaron matriculadas</span>
              </v-tooltip>
            </div>
            <div v-else class="funnel-error">{{ errorConversion }}</div>
          </div>
        </div>

        <div class="funnel-bridge">
          <div v-if="!errorConversion" class="funnel-chips">
            <v-chip
              v-for="chip in chipsFase3"
              :key="chip.id"
              small
              label
              class="ma-1 funnel-chip"
              :color="chip.color"
              dark
              @click="abrirValidacion(chip)"
            >
              <v-icon left x-small>{{ chip.icon }}</v-icon>
              {{ chip.label }}
            </v-chip>
          </div>
          <v-chip
            v-if="!errorConversion && !errorFidelizacion"
            small
            outlined
            class="funnel-chip-bridge ma-1"
            @click="abrirValidacion(chipPuente34)"
          >
            <v-icon left x-small>mdi-arrow-down-bold</v-icon>
            {{ chipPuente34.label }}
          </v-chip>
        </div>

        <!-- Fase 4 -->
        <div class="funnel-stage stage-4">
          <div class="funnel-stage__inner">
            <div class="funnel-stage__title">
              <v-icon color="white" small class="mr-1">mdi-account-heart-outline</v-icon>
              Fidelización
            </div>
            <div class="funnel-stage__subtitle">Aumentar ventas / retención</div>
            <div v-if="!errorFidelizacion" class="funnel-metrics funnel-metrics--triple">
              <v-tooltip bottom max-width="280" color="grey darken-3">
                <template v-slot:activator="{ on, attrs }">
                  <div class="funnel-metric" v-bind="attrs" v-on="on">
                    <div class="funnel-metric__label">
                      Upselling
                      <v-icon x-small color="white" class="ml-1">mdi-information-outline</v-icon>
                    </div>
                    <div class="funnel-metric__value">{{ formatNumber(fidelizacion.upselling) }}</div>
                  </div>
                </template>
                <span>Inscritos que compraron certificación (CERTI) con pago real</span>
              </v-tooltip>
              <v-tooltip bottom max-width="280" color="grey darken-3">
                <template v-slot:activator="{ on, attrs }">
                  <div class="funnel-metric" v-bind="attrs" v-on="on">
                    <div class="funnel-metric__label">
                      Reinscritos
                      <v-icon x-small color="white" class="ml-1">mdi-information-outline</v-icon>
                    </div>
                    <div class="funnel-metric__value">{{ formatNumber(fidelizacion.reinscritos) }}</div>
                  </div>
                </template>
                <span>Rompieron la primera compra e inscribieron un segundo ciclo regular</span>
              </v-tooltip>
              <v-tooltip bottom max-width="280" color="grey darken-3">
                <template v-slot:activator="{ on, attrs }">
                  <div class="funnel-metric" v-bind="attrs" v-on="on">
                    <div class="funnel-metric__label">
                      Graduados
                      <v-icon x-small color="white" class="ml-1">mdi-information-outline</v-icon>
                    </div>
                    <div class="funnel-metric__value">{{ formatNumber(fidelizacion.graduados) }}</div>
                  </div>
                </template>
                <span>Terminaron el curso (NIVEL 14 / TEENS NIVEL 16)</span>
              </v-tooltip>
            </div>
            <div v-else class="funnel-error">{{ errorFidelizacion }}</div>
          </div>
        </div>

        <div v-if="!errorFidelizacion" class="funnel-bridge">
          <div class="funnel-chips">
            <v-chip
              v-for="chip in chipsFase4"
              :key="chip.id"
              small
              label
              class="ma-1 funnel-chip"
              :color="chip.color"
              dark
              @click="abrirValidacion(chip)"
            >
              <v-icon left x-small>{{ chip.icon }}</v-icon>
              {{ chip.label }}
            </v-chip>
          </div>
        </div>
      </div>
    </div>

    <v-row v-else-if="!cargando" class="mt-8">
      <v-col cols="12" class="text-center grey--text">
        Selecciona fechas y escuela, luego pulsa <strong>Consultar</strong> para cargar las 4 fases del embudo.
      </v-col>
    </v-row>

    <v-dialog v-model="dialogValidacion" max-width="520">
      <v-card v-if="validacionActiva">
        <v-card-title class="text-subtitle-1 font-weight-bold">
          <v-icon left :color="validacionActiva.color || 'primary'">{{ validacionActiva.icon }}</v-icon>
          {{ validacionActiva.titulo }}
        </v-card-title>
        <v-card-text>
          <div class="mb-3 text-body-2">{{ validacionActiva.descripcion }}</div>

          <v-simple-table dense v-if="validacionActiva.filas && validacionActiva.filas.length">
            <template v-slot:default>
              <tbody>
                <tr v-for="(fila, idx) in validacionActiva.filas" :key="idx">
                  <td class="font-weight-medium">{{ fila.label }}</td>
                  <td class="text-right">{{ fila.valor }}</td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>

          <v-alert
            v-if="validacionActiva.formula"
            dense
            text
            color="blue-grey"
            class="mt-3 mb-0"
          >
            <div class="text-caption font-weight-bold mb-1">Fórmula</div>
            <div class="text-body-2">{{ validacionActiva.formula }}</div>
          </v-alert>

          <v-alert
            v-if="validacionActiva.nota"
            dense
            text
            type="info"
            class="mt-3 mb-0"
          >
            {{ validacionActiva.nota }}
          </v-alert>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn text color="primary" @click="dialogValidacion = false">Cerrar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-snackbar v-model="snackbar" :color="snackbarColor" top right>
      {{ snackbarMsg }}
      <template v-slot:action="{ attrs }">
        <v-btn text v-bind="attrs" @click="snackbar = false">OK</v-btn>
      </template>
    </v-snackbar>
  </v-container>
</template>

<script>
export default {
  name: 'EmbudoVentasFases',

  data () {
    return {
      fechaInicio: new Date(new Date().setDate(1)).toISOString().substr(0, 10),
      fechaFin: new Date().toISOString().substr(0, 10),
      escuela: 1,
      escuelas: [
        { id: 1, nombre: 'INBI' },
        { id: 2, nombre: 'FAST' }
      ],
      plantelesAll: [],
      plantelesSel: [],
      cargandoPlanteles: false,
      menuFechaInicio: false,
      menuFechaFin: false,
      cargando: false,
      datosCargados: false,
      atraccionData: {},
      interaccionData: {},
      conversionData: {},
      fidelizacionData: {},
      errorAtraccion: '',
      errorInteraccion: '',
      errorConversion: '',
      errorFidelizacion: '',
      snackbar: false,
      snackbarMsg: '',
      snackbarColor: 'success',
      dialogValidacion: false,
      validacionActiva: null
    }
  },

  computed: {
    metaConsulta () {
      const esc = this.escuela === 2 ? 'FAST' : 'INBI'
      let plantelesTxt = 'Todos los planteles'
      if (this.plantelesSel && this.plantelesSel.length) {
        const nombres = this.plantelesEscuela
          .filter((p) => this.plantelesSel.includes(p.id_plantel))
          .map((p) => p.plantel)
        plantelesTxt = nombres.length ? nombres.join(', ') : `${this.plantelesSel.length} plantel(es)`
      }
      return `${esc} · ${plantelesTxt} · ${this.fechaInicio} → ${this.fechaFin}`
    },
    plantelesEscuela () {
      const lista = this.plantelesAll || []
      const esFast = Number(this.escuela) === 2
      return lista.filter((p) => {
        const nombre = String((p && p.plantel) || '').toUpperCase()
        if (!nombre) return false
        // Misma convención del sistema: FAST en el nombre = escuela FAST; resto = INBI
        const esPlantelFast = nombre.includes('FAST')
        return esFast ? esPlantelFast : !esPlantelFast
      })
    },
    atraccion () {
      return (this.atraccionData && this.atraccionData.atraccion) || {
        alcance: 0,
        interacciones: 0
      }
    },
    interaccion () {
      return (this.interaccionData && this.interaccionData.interaccion) || {
        contactos: 0,
        contactos_calificados: 0
      }
    },
    conversion () {
      return (this.conversionData && this.conversionData.conversion) || {
        inscritos: 0
      }
    },
    fidelizacion () {
      return (this.fidelizacionData && this.fidelizacionData.fidelizacion) || {
        upselling: 0,
        reinscritos: 0,
        graduados: 0,
        inscritos_base: 0
      }
    },
    inscritosBase () {
      const fromFid = Number(this.fidelizacion.inscritos_base)
      if (fromFid > 0) return fromFid
      return Number(this.conversion.inscritos) || 0
    },
    tasaEngagement () {
      return this.pct(this.atraccion.interacciones, this.atraccion.alcance)
    },
    tasaCalificacion () {
      const api = this.interaccionData && this.interaccionData.interaccion
      if (api && api.tasa_calificacion_pct != null) return Number(api.tasa_calificacion_pct)
      return this.pct(this.interaccion.contactos_calificados, this.interaccion.contactos)
    },
    tasaCierre () {
      const api = this.conversionData && this.conversionData.conversion
      if (api && api.tasa_cierre_pct != null) return Number(api.tasa_cierre_pct)
      return this.pct(this.conversion.inscritos, this.interaccion.contactos)
    },
    tasaReinscritos () {
      return this.pct(this.fidelizacion.reinscritos, this.inscritosBase)
    },
    chipsFase1 () {
      return [
        {
          id: 'f1-tasa',
          label: `Tasa eng. ${this.formatPct(this.tasaEngagement)}`,
          icon: 'mdi-percent',
          color: 'amber darken-3',
          titulo: 'Validar Atracción — Tasa de engagement',
          descripcion: 'Porcentaje de personas del alcance que interactuaron con la pauta.',
          formula: 'Interacciones ÷ Alcance × 100',
          filas: [
            { label: 'Alcance', valor: this.formatNumber(this.atraccion.alcance) },
            { label: 'Interacciones', valor: this.formatNumber(this.atraccion.interacciones) },
            { label: 'Tasa engagement', valor: this.formatPct(this.tasaEngagement) }
          ],
          nota: 'Fuente: Meta Ads (Graph) a nivel cuenta. El filtro de plantel no aplica a esta fase (sí a Interacción–Fidelización).'
        },
        {
          id: 'f1-fuente',
          label: 'Fuente: Meta Ads',
          icon: 'mdi-facebook',
          color: 'blue-grey darken-1',
          titulo: 'Validar Atracción — Fuente',
          descripcion: 'Alcance e interacciones salen de insights de la cuenta de anuncios Meta (nivel account).',
          formula: 'reach + unique_actions/actions de engagement',
          filas: [
            { label: 'Escuela', valor: this.escuela === 2 ? 'FAST' : 'INBI' },
            { label: 'Rango', valor: `${this.fechaInicio} → ${this.fechaFin}` },
            { label: 'Alcance', valor: this.formatNumber(this.atraccion.alcance) },
            { label: 'Interacciones', valor: this.formatNumber(this.atraccion.interacciones) }
          ],
          nota: 'No se espera que iguale Contactos de fase 2: son universos distintos.'
        }
      ]
    },
    chipsFase2 () {
      return [
        {
          id: 'f2-tasa',
          label: `Tasa calif. ${this.formatPct(this.tasaCalificacion)}`,
          icon: 'mdi-percent',
          color: 'deep-orange darken-2',
          titulo: 'Validar Interacción — Tasa de calificación',
          descripcion: 'De los contactos Meta, cuántos sostuvieron chat bidireccional en el mismo rango.',
          formula: 'Contactos calificados ÷ Contactos × 100',
          filas: [
            { label: 'Contactos Meta', valor: this.formatNumber(this.interaccion.contactos) },
            { label: 'Contactos calificados', valor: this.formatNumber(this.interaccion.contactos_calificados) },
            { label: 'Tasa calificación', valor: this.formatPct(this.tasaCalificacion) }
          ],
          nota: 'Calificado = ≥1 mensaje del lead + ≥1 respuesta (bot/asesor), solo en el rango consultado.'
        },
        {
          id: 'f2-meta',
          label: 'Atribución Meta',
          icon: 'mdi-check-decagram',
          color: 'blue-grey darken-1',
          titulo: 'Validar Interacción — Atribución Meta',
          descripcion: 'Solo entran prospectos con teléfono atribuidos a Meta.',
          formula: 'Referral Twilio Meta (CtwaClid / fb.me / etc.) Ó fuente tipada Meta Ads',
          filas: [
            { label: 'Contactos únicos', valor: this.formatNumber(this.interaccion.contactos) },
            { label: 'Escuela', valor: this.escuela === 2 ? 'FAST' : 'INBI' },
            { label: 'Rango llegada', valor: `${this.fechaInicio} → ${this.fechaFin}` }
          ],
          nota: 'No incluye FB/IG orgánico ni “anuncio” genérico.'
        }
      ]
    },
    chipsFase3 () {
      return [
        {
          id: 'f3-tasa',
          label: `Tasa cierre ${this.formatPct(this.tasaCierre)}`,
          icon: 'mdi-percent',
          color: 'green darken-2',
          titulo: 'Validar Conversión — Tasa de cierre',
          descripcion: 'Inscritos sobre contactos Meta de la cohorte.',
          formula: 'Inscritos ÷ Contactos × 100',
          filas: [
            { label: 'Contactos base', valor: this.formatNumber(this.interaccion.contactos) },
            { label: 'Inscritos', valor: this.formatNumber(this.conversion.inscritos) },
            { label: 'Tasa cierre', valor: this.formatPct(this.tasaCierre) }
          ],
          nota: 'Inscrito = alumno ERP con ingresos.monto_pagado > 0. El pago puede ser posterior al rango.'
        },
        {
          id: 'f3-regla',
          label: '1 prospecto = 1 inscrito',
          icon: 'mdi-account-check',
          color: 'blue-grey darken-1',
          titulo: 'Validar Conversión — Deduplicación',
          descripcion: 'Si un prospecto tiene varios alumnos/pagos, se cuenta uno solo (primer pago más antiguo).',
          formula: 'canonicalInscritosPorProspecto(ingresos)',
          filas: [
            { label: 'Inscritos canónicos', valor: this.formatNumber(this.conversion.inscritos) },
            { label: 'Base contactos Meta', valor: this.formatNumber(this.interaccion.contactos) }
          ],
          nota: 'Misma base canónica se usa en Fidelización.'
        }
      ]
    },
    chipsFase4 () {
      return [
        {
          id: 'f4-reins',
          label: `Reinscrip. ${this.formatPct(this.tasaReinscritos)}`,
          icon: 'mdi-percent',
          color: 'blue darken-2',
          titulo: 'Validar Fidelización — Reinscritos',
          descripcion: 'Porcentaje de inscritos de la cohorte con ≥2 ciclos regulares pagados.',
          formula: 'Reinscritos ÷ Inscritos base × 100',
          filas: [
            { label: 'Inscritos base', valor: this.formatNumber(this.inscritosBase) },
            { label: 'Reinscritos', valor: this.formatNumber(this.fidelizacion.reinscritos) },
            { label: 'Upselling', valor: this.formatNumber(this.fidelizacion.upselling) },
            { label: 'Graduados', valor: this.formatNumber(this.fidelizacion.graduados) },
            { label: '% reincripción', valor: this.formatPct(this.tasaReinscritos) }
          ],
          nota: 'INBI: CICLO MM_YY · FAST: CICLO MM_YY FE. Excluye CERTI, EXCI, inducción, cambios y excedentes.'
        },
        {
          id: 'f4-base',
          label: `Base ${this.formatNumber(this.inscritosBase)} inscritos`,
          icon: 'mdi-database',
          color: 'blue-grey darken-1',
          titulo: 'Validar Fidelización — Base',
          descripcion: 'Upselling, reinscritos y graduados se miden solo sobre los inscritos canónicos de la cohorte Meta.',
          formula: 'Misma lista de alumnos que Conversión',
          filas: [
            { label: 'Inscritos base', valor: this.formatNumber(this.inscritosBase) },
            { label: 'Upselling (CERTI pagado)', valor: this.formatNumber(this.fidelizacion.upselling) },
            { label: 'Reinscritos (≥2 ciclos)', valor: this.formatNumber(this.fidelizacion.reinscritos) },
            { label: 'Graduados (N14 / Teens N16)', valor: this.formatNumber(this.fidelizacion.graduados) }
          ],
          nota: 'Los eventos de fidelización pueden ocurrir después del rango de fechas.'
        }
      ]
    },
    chipPlantelFase1 () {
      const plantelesTxt = (this.plantelesSel && this.plantelesSel.length)
        ? `${this.plantelesSel.length} plantel(es) seleccionado(s)`
        : 'Sin plantel (todos)'
      return {
        id: 'f1-plantel',
        label: 'Plantel no aplica en Atracción (Meta a nivel cuenta)',
        icon: 'mdi-map-marker-off',
        color: 'grey',
        titulo: 'Atracción — Filtro de plantel',
        descripcion:
          'Alcance e interacciones vienen de Meta Ads a nivel cuenta (INBI o FAST). El filtro de plantel no cambia esos números.',
        formula: 'Insights Meta level=account · plantel solo filtra fases 2–4 (CRM)',
        filas: [
          { label: 'Escuela Meta', valor: this.escuela === 2 ? 'FAST' : 'INBI' },
          { label: 'Filtro plantel actual', valor: plantelesTxt },
          { label: 'Alcance (cuenta)', valor: this.formatNumber(this.atraccion.alcance) },
          { label: 'Interacciones (cuenta)', valor: this.formatNumber(this.atraccion.interacciones) }
        ],
        nota: 'Si eliges un plantel (ej. Montevideo), Interacción / Conversión / Fidelización sí se filtran; Atracción sigue mostrando el total de la cuenta Meta.'
      }
    },
    chipPuente12 () {
      return {
        id: 'p12',
        label: 'Meta Ads ≠ CRM (universos distintos)',
        icon: 'mdi-arrow-down-bold',
        color: 'grey',
        titulo: 'Puente Atracción → Interacción',
        descripcion: 'No compares Alcance/Interacciones uno a uno con Contactos: fase 1 es Meta Ads y fase 2 es CRM+Twilio con atribución Meta.',
        formula: 'Contactos ⊆ prospectos con teléfono atribuidos a Meta en el rango',
        filas: [
          { label: 'Interacciones (Meta)', valor: this.formatNumber(this.atraccion.interacciones) },
          { label: 'Contactos (CRM Meta)', valor: this.formatNumber(this.interaccion.contactos) }
        ],
        nota: 'Una caída grande aquí es esperada y no indica error por sí sola.'
      }
    },
    chipPuente23 () {
      return {
        id: 'p23',
        label: `Cierre ${this.formatPct(this.tasaCierre)} · ${this.formatNumber(this.conversion.inscritos)} inscritos`,
        icon: 'mdi-arrow-down-bold',
        color: 'grey',
        titulo: 'Puente Interacción → Conversión',
        descripcion: 'De contactos Meta a inscritos con pago real en ERP.',
        formula: 'Inscritos ÷ Contactos × 100',
        filas: [
          { label: 'Contactos', valor: this.formatNumber(this.interaccion.contactos) },
          { label: 'Calificados', valor: this.formatNumber(this.interaccion.contactos_calificados) },
          { label: 'Inscritos', valor: this.formatNumber(this.conversion.inscritos) },
          { label: 'Tasa cierre', valor: this.formatPct(this.tasaCierre) }
        ],
        nota: 'Cohorte por fecha de llegada; el pago puede ser después del rango.'
      }
    },
    chipPuente34 () {
      return {
        id: 'p34',
        label: `Retención ${this.formatPct(this.tasaReinscritos)} sobre inscritos`,
        icon: 'mdi-arrow-down-bold',
        color: 'grey',
        titulo: 'Puente Conversión → Fidelización',
        descripcion: 'Fidelización parte de los mismos inscritos canónicos (no de todos los contactos).',
        formula: 'Reinscritos ÷ Inscritos base × 100',
        filas: [
          { label: 'Inscritos', valor: this.formatNumber(this.inscritosBase) },
          { label: 'Reinscritos', valor: this.formatNumber(this.fidelizacion.reinscritos) },
          { label: '% reincripción', valor: this.formatPct(this.tasaReinscritos) }
        ],
        nota: '87 reinscritos sobre ~135 inscritos es ~64%, no sobre los 10k contactos.'
      }
    }
  },

  mounted () {
    this.getPlanteles()
  },

  methods: {
    formatNumber (n) {
      const num = Number(n) || 0
      return num.toLocaleString('es-MX')
    },
    pct (num, den) {
      const n = Number(num) || 0
      const d = Number(den) || 0
      if (d <= 0) return 0
      return Number(((n / d) * 100).toFixed(2))
    },
    formatPct (value) {
      const n = Number(value)
      if (!Number.isFinite(n)) return '0%'
      return `${n.toLocaleString('es-MX', { maximumFractionDigits: 2 })}%`
    },
    abrirValidacion (chip) {
      this.validacionActiva = chip || null
      this.dialogValidacion = !!chip
    },
    onEscuelaChange () {
      this.plantelesSel = []
    },
    getPlanteles () {
      this.cargandoPlanteles = true
      this.$http.get('kpi.planteles.all').then((response) => {
        this.plantelesAll = response.data || []
      }).catch((e) => {
        console.error(e)
        this.plantelesAll = []
      }).finally(() => {
        this.cargandoPlanteles = false
      })
    },
    mostrarSnack (msg, color) {
      this.snackbarMsg = msg
      this.snackbarColor = color || 'success'
      this.snackbar = true
    },
    extraerError (e, fallback) {
      const body = (e && e.body) || (e && e.response && e.response.data) || {}
      const detalle = body.error
        ? (typeof body.error === 'string' ? body.error : (body.error.message || JSON.stringify(body.error)))
        : ''
      const msg = body.message || fallback
      return detalle ? `${msg}: ${detalle}` : msg
    },
    async consultar () {
      if (!this.fechaInicio || !this.fechaFin) {
        this.mostrarSnack('Selecciona rango de fechas', 'error')
        return
      }
      if (this.fechaInicio > this.fechaFin) {
        this.mostrarSnack('La fecha inicio no puede ser mayor que la fecha fin', 'error')
        return
      }

      const payload = {
        escuela: this.escuela,
        fechaInicio: this.fechaInicio,
        fechaFin: this.fechaFin,
        planteles: this.plantelesSel || []
      }

      this.cargando = true
      this.errorAtraccion = ''
      this.errorInteraccion = ''
      this.errorConversion = ''
      this.errorFidelizacion = ''

      try {
        const [resAtraccion, resInteraccion, resConversion, resFidelizacion] = await Promise.allSettled([
          this.$http.post('kpi.embudo.fases.atraccion', payload),
          this.$http.post('kpi.embudo.fases.interaccion', payload),
          this.$http.post('kpi.embudo.fases.conversion', payload),
          this.$http.post('kpi.embudo.fases.fidelizacion', payload)
        ])

        if (resAtraccion.status === 'fulfilled') {
          this.atraccionData = (resAtraccion.value && resAtraccion.value.data) || {}
        } else {
          this.atraccionData = {}
          this.errorAtraccion = this.extraerError(resAtraccion.reason, 'Error en Atracción (Meta)')
        }

        if (resInteraccion.status === 'fulfilled') {
          this.interaccionData = (resInteraccion.value && resInteraccion.value.data) || {}
        } else {
          this.interaccionData = {}
          this.errorInteraccion = this.extraerError(resInteraccion.reason, 'Error en Interacción')
        }

        if (resConversion.status === 'fulfilled') {
          this.conversionData = (resConversion.value && resConversion.value.data) || {}
        } else {
          this.conversionData = {}
          this.errorConversion = this.extraerError(resConversion.reason, 'Error en Conversión')
        }

        if (resFidelizacion.status === 'fulfilled') {
          this.fidelizacionData = (resFidelizacion.value && resFidelizacion.value.data) || {}
        } else {
          this.fidelizacionData = {}
          this.errorFidelizacion = this.extraerError(resFidelizacion.reason, 'Error en Fidelización')
        }

        this.datosCargados = true

        const resultados = [resAtraccion, resInteraccion, resConversion, resFidelizacion]
        const ok = resultados.filter((r) => r.status === 'fulfilled').length
        if (ok === 4) {
          this.mostrarSnack('Fases 1–4 actualizadas', 'success')
        } else if (ok > 0) {
          this.mostrarSnack(`${ok} de 4 fases OK; revisa errores en las demás`, 'warning')
        } else {
          this.mostrarSnack('Error al consultar las fases', 'error')
        }
      } catch (e) {
        console.error(e)
        this.mostrarSnack(this.extraerError(e, 'Error al consultar embudo'), 'error')
      } finally {
        this.cargando = false
      }
    }
  }
}
</script>

<style scoped>
.funnel-wrap {
  max-width: 880px;
  margin: 0 auto;
}

.funnel {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.funnel-stage {
  color: #fff;
  position: relative;
  width: 100%;
  box-sizing: border-box;
  filter: drop-shadow(0 6px 12px rgba(0, 0, 0, 0.16));
}

/* Altura = contenido; mismo padding vertical en todas las fases */
.funnel-stage__inner {
  text-align: center;
  padding: 18px 12% 20px;
  box-sizing: border-box;
}

.funnel-stage__title {
  font-size: 1.3rem;
  font-weight: 800;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  line-height: 1.25;
}

.funnel-stage__subtitle {
  font-size: 0.88rem;
  opacity: 0.92;
  margin-top: 4px;
  margin-bottom: 16px;
}

.funnel-metrics {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 12px 16px;
}

.funnel-metric {
  min-width: 118px;
  background: rgba(0, 0, 0, 0.16);
  border-radius: 8px;
  padding: 10px 14px;
  cursor: help;
}

.funnel-metric__label {
  font-size: 0.68rem;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  opacity: 0.9;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.funnel-metric__value {
  font-size: 1.4rem;
  font-weight: 800;
  line-height: 1.15;
}

.funnel-metrics--triple {
  flex-direction: column;
  align-items: stretch;
  gap: 8px;
  width: 100%;
  max-width: 260px;
  margin: 0 auto;
}

.funnel-metrics--triple > span {
  display: block;
  width: 100%;
}

.funnel-metrics--triple .funnel-metric {
  min-width: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding: 10px 12px;
  text-align: left;
}

.funnel-metrics--triple .funnel-metric__value {
  font-size: 1.2rem;
}

.funnel-error {
  font-size: 0.8rem;
  opacity: 0.95;
  max-width: 85%;
  margin: 0 auto;
}

.funnel-chips {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 2px;
}

.funnel-chip {
  cursor: pointer;
  font-weight: 600;
  height: 26px !important;
}

.funnel-bridge {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 4px;
  padding: 8px 8px 10px;
  z-index: 2;
}

.funnel-chip-bridge {
  cursor: pointer;
  background: #fff !important;
  font-weight: 600;
  height: 28px !important;
}

/*
  Embudo más suave: más ancho abajo para que Conversión/Fidelización
  no queden apretados. Chips fuera del clip-path (en bridges).
*/
.stage-1 {
  background: linear-gradient(180deg, #ffd54f 0%, #f9a825 55%, #f57f17 100%);
  clip-path: polygon(0% 0%, 100% 0%, 90% 100%, 10% 100%);
}

.stage-2 {
  background: linear-gradient(180deg, #ff9800 0%, #ef6c00 55%, #e65100 100%);
  clip-path: polygon(10% 0%, 90% 0%, 78% 100%, 22% 100%);
}

.stage-3 {
  background: linear-gradient(180deg, #66bb6a 0%, #43a047 55%, #2e7d32 100%);
  clip-path: polygon(22% 0%, 78% 0%, 66% 100%, 34% 100%);
}

.stage-4 {
  background: linear-gradient(180deg, #42a5f5 0%, #1e88e5 55%, #1565c0 100%);
  clip-path: polygon(34% 0%, 66% 0%, 66% 100%, 34% 100%);
}

.stage-1 .funnel-stage__inner { padding: 18px 8% 20px; }
.stage-2 .funnel-stage__inner { padding: 18px 14% 20px; }
.stage-3 .funnel-stage__inner { padding: 18px 24% 20px; }
.stage-4 .funnel-stage__inner { padding: 18px 36% 20px; }

@media (max-width: 960px) {
  .funnel-wrap {
    max-width: 100%;
  }

  .funnel-stage__title {
    font-size: 1.05rem;
  }

  .funnel-metric__value {
    font-size: 1.2rem;
  }

  .stage-1 .funnel-stage__inner { padding: 16px 6% 18px; }
  .stage-2 .funnel-stage__inner { padding: 16px 12% 18px; }
  .stage-3 .funnel-stage__inner { padding: 16px 22% 18px; }
  .stage-4 .funnel-stage__inner { padding: 16px 34% 18px; }
}

@media (max-width: 600px) {
  .stage-1 { clip-path: polygon(0% 0%, 100% 0%, 92% 100%, 8% 100%); }
  .stage-2 { clip-path: polygon(8% 0%, 92% 0%, 82% 100%, 18% 100%); }
  .stage-3 { clip-path: polygon(18% 0%, 82% 0%, 70% 100%, 30% 100%); }
  .stage-4 { clip-path: polygon(30% 0%, 70% 0%, 70% 100%, 30% 100%); }

  .stage-1 .funnel-stage__inner { padding: 14px 6% 16px; }
  .stage-2 .funnel-stage__inner { padding: 14px 12% 16px; }
  .stage-3 .funnel-stage__inner { padding: 14px 20% 16px; }
  .stage-4 .funnel-stage__inner { padding: 14px 32% 16px; }

  .funnel-metric {
    min-width: 42%;
    flex: 1 1 40%;
  }

  .funnel-metrics--triple {
    max-width: 100%;
  }
}
</style>
